<template>
  <div class="bg-white md:pt-32 lg:pt-32 pt-24 relative">
    <div class="absolute top-48 right-0 md:block lg:bloch hidden">
      <img
        src="./../../assets/images/bg-des/career-dots.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute top-1/3 left-0 md:block lg:bloch hidden">
      <img
        src="./../../assets/images/bg-des/CD-dots2.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute top-48 left-1/4 md:block lg:bloch hidden">
      <img
        src="./../../assets/images/bg-des/career-poly.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute top-1/3 right-32 md:block lg:bloch hidden">
      <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="absolute top-1/2 left-32 md:block lg:bloch hidden">
      <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="absolute top-48 right-1/4 md:block lg:bloch hidden">
      <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="md:w-4/5 lg:w-4/5 w-full mx-auto">
      <div class="flex justify-between items-center">
        <div class="flex items-center">
          <p class="fsize48-24 font-semibold text-black">Product Designer</p>
          <img
            src="./../../assets/images/logo/career-share.svg"
            alt="ShareIcon"
            class="md:h-8 lg:h-8 h-4 ml-4"
          />
        </div>
        <div class="md:block lg:bloch hidden">
          <base-button type="primary" class="px-12 py-2 fs16700 border-2"
            >Apply</base-button
          >
        </div>
      </div>
      <p class="joinus-subtitle clr777 fsize24-14px">Location</p>
      <div class="md:pt-20 lg:pt-20 pt-8">
        <div>
          <p class="underline care-det-title text-black fsize24-14px">
            About the role
          </p>
          <p class="pt-6 subtitle tracking-wide fsize24-14px">
            Consectetur adipiscing elit. Suspendisse enim viverra dui at
            eleifend tellus arcu ultricies. Suspendisse enim viverra dui at
            eleifend tellus arcu ultricies. A nisi, neque, augue viverra magna
            suspendisse rhoncus, semper mauris. Lorem ipsum dolor sit amet,
            consectetur adipiscing elit.
          </p>
        </div>

        <div class="md:pt-10 lg:pt-10 pt-8">
          <p class="underline care-det-title text-black fsize24-14px">
            Minimum Qualification
          </p>
          <ul
            class="
              pt-4
              md:pl-6
              lg:pl-6
              pl-4
              subtitle
              tracking-wide
              fsize24-14px
            "
          >
            <li>
              Consectetur adipiscing elit. Suspendisse enim viverra dui at
              eleifend tellus arcu ultricies.
            </li>
            <li>
              Suspendisse enim viverra dui at eleifend tellus arcu ultricies.
            </li>
            <li>
              A nisi, neque, augue viverra magna suspendisse rhoncus, semper
              mauris. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </li>
            <li>
              Consectetur adipiscing elit. Suspendisse enim viverra dui at
              eleifend tellus arcu ultricies.
            </li>
            <li>
              Suspendisse enim viverra dui at eleifend tellus arcu ultricies.
            </li>
            <li>
              A nisi, neque, augue viverra magna suspendisse rhoncus, semper
              mauris. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </li>
          </ul>
        </div>
      </div>

      <div class="md:pt-20 lg:pt-20 pt-12">
        <div class="w-full bgE4D8F5 relative z-index1">
          <div class="absolute top-0 left-0 z-index--1">
            <img src="./../../assets/images/bg-des/form-t1.svg" alt="Bg des" />
          </div>
          <ApplyJob :subject="subject" />
        </div>
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555 mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<style scoped>
li {
  padding-top: 10px;
  list-style: disc;
}
</style>
<script>
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
import ApplyJob from "./components/ApplyJob.vue";

export default {
  components: {
    DownloadApp,
    Footer,
    ApplyJob,
  },
  data() {
    return {
      subject: "Product Designer",
    };
  },
};
</script>
